import KeywordButtonDefault from "@components/Button/components/KeywordButton/KeywordButtonDefault";
import KeywordButtonVersion2 from "@components/Button/components/KeywordButton/KeywordButtonVersion2";
import KeywordButtonVersion3 from "@components/Button/components/KeywordButton/KeywordButtonVersion3";
import { KeywordButtonType } from "@components/Button/utils/types";

export const KeywordButtonFactory = ({
  keywordButtonType = KeywordButtonType.default,
}) => {
  switch (keywordButtonType) {
    case KeywordButtonType.version2:
      return KeywordButtonVersion2;

    case KeywordButtonType.version3:
      return KeywordButtonVersion3;

    default:
      return KeywordButtonDefault;
  }
};
